import type {
  CalendarApi,
  CalendarApiUpdateQuery,
  CalendarAuthRedirectApi,
  CalendarEventApi,
  CalendarEventFilterQueryApi,
  CalendarEventReminderApi,
  CalendarsConfigApi,
} from "@/Modules/Calendars/Models/Api";
import { get2, getFullDataPaginated, patch2, post2, remove2 } from "./utils/FunctionalTherapyApi";
import type {
  CalendarEventCreateQueryApi,
  CalendarEventUpdateQueryApi,
} from "@/Modules/Calendars/Models/Api";

export function getCalendars(): Promise<CalendarApi[]> {
  return get2<{ page_size: number }, CalendarApi[]>("v1.0/calendars", { page_size: 1000 });
}

const CALENDAR_EVENTS_PAGE_SIZE = 200;

export function getCalendarsEvents(query: CalendarEventFilterQueryApi = {}): Promise<CalendarEventApi[]> {
  return getFullDataPaginated<CalendarEventFilterQueryApi, CalendarEventApi>("v1.0/calendars/events", {
    ...query,
    page_size: CALENDAR_EVENTS_PAGE_SIZE,
  });
}

export function removeIntegration(provider: string, id: string): Promise<void> {
  return remove2<void, void>(`v1.0/calendars/${provider}/${id}`);
}

export function getAuthLink(provider: string): Promise<CalendarAuthRedirectApi> {
  return get2<void, CalendarAuthRedirectApi>(`v1.0/calendars/${provider}/init`);
}

export function updateCalendar(calendarId: string, query: CalendarApiUpdateQuery): Promise<CalendarApi> {
  return patch2<CalendarApiUpdateQuery, CalendarApi>(`v1.0/calendars/${calendarId}`, query);
}

export function createEvent(
  calendarUuid: string,
  query: CalendarEventCreateQueryApi
): Promise<CalendarEventApi> {
  return post2<CalendarEventCreateQueryApi, CalendarEventApi>(`v1.0/calendars/${calendarUuid}/events`, query);
}

export function updateEvent(
  calendarUuid: string,
  eventUUid: string,
  query: CalendarEventUpdateQueryApi
): Promise<CalendarEventApi> {
  return patch2<CalendarEventUpdateQueryApi, CalendarEventApi>(
    `v1.0/calendars/${calendarUuid}/events/${eventUUid}`,
    query
  );
}

export function deleteEvent(calendarUuid: string, eventUUid: string): Promise<CalendarEventApi> {
  return remove2<void, CalendarEventApi>(`v1.0/calendars/${calendarUuid}/events/${eventUUid}`);
}

export function fetchConfig(): Promise<CalendarsConfigApi> {
  return get2<void, CalendarsConfigApi>("v1.0/calendars/config");
}

export function updateConfig(config: CalendarsConfigApi): Promise<CalendarsConfigApi> {
  return patch2<CalendarsConfigApi, CalendarsConfigApi>("v1.0/calendars/config", config);
}

export function createReminder(
  reminder: Omit<CalendarEventReminderApi, "uuid">
): Promise<CalendarEventReminderApi> {
  return post2<Omit<CalendarEventReminderApi, "uuid">, CalendarEventReminderApi>(
    "v1.0/calendars/config/reminders",
    reminder
  );
}

export function updateReminder(
  uuid: string,
  reminder: CalendarEventReminderApi
): Promise<CalendarEventReminderApi> {
  return patch2<CalendarEventReminderApi, CalendarEventReminderApi>(
    `v1.0/calendars/config/reminders/${uuid}`,
    reminder
  );
}

export function deleteReminder(uuid: string): Promise<CalendarEventReminderApi> {
  return remove2<void, CalendarEventReminderApi>(`v1.0/calendars/config/reminders/${uuid}`);
}
